function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-id-pass_svg__cls-3,.icon-id-pass_svg__cls-6{fill:none}.icon-id-pass_svg__cls-3,.icon-id-pass_svg__cls-4{stroke:#3fa9f5;stroke-width:1.5px}.icon-id-pass_svg__cls-3,.icon-id-pass_svg__cls-4,.icon-id-pass_svg__cls-6{stroke-linecap:round;stroke-linejoin:round}.icon-id-pass_svg__cls-4{fill:#3fa9f5}.icon-id-pass_svg__cls-6{stroke:#fff;stroke-width:2px}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon-id-pass_svg__Layer_3",
  "data-name": "Layer 3"
}, /*#__PURE__*/React.createElement("rect", {
  x: 4.39,
  y: 5.97,
  width: 60.02,
  height: 45.24,
  rx: 6.23,
  strokeMiterlimit: 10,
  fill: "#fff",
  stroke: "#cccbcb",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 13.99,
  y: 15.52,
  width: 39.1,
  height: 26.67,
  rx: 5,
  stroke: "#3fa9f5",
  strokeWidth: 1.5,
  fill: "none",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-id-pass_svg__cls-3",
  d: "M35.11 22.26h12.15M35.11 27.14h12.15M35.11 32.03h8.2"
}), /*#__PURE__*/React.createElement("circle", {
  className: "icon-id-pass_svg__cls-4",
  cx: 25.51,
  cy: 24.72,
  r: 3.65
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-id-pass_svg__cls-4",
  d: "M23.46 28.37c-2.85.41-3.93 6.42-3.84 7.25s5.89 1 5.89 1v-8.25zM27.56 28.37c2.85.41 3.92 6.42 3.83 7.25s-5.88 1-5.88 1v-8.25z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49.73,
  cy: 40.09,
  r: 7.84,
  fill: "#3fa9f5"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-id-pass_svg__cls-6",
  d: "M46.46 40.47l2.46 2.18M53 37.54l-4.08 5.11"
}));

function SvgIconIdPass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 69.69 56.69"
  }, props), _ref, _ref2);
}

export default SvgIconIdPass;